export enum BlockadeType{
  tillCancelation = "0",
  tillDate = "1"
}
